import React from 'react';
const FiFlag = () => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0_40010504_56381)" },
        React.createElement("rect", { width: "24", height: "24", fill: "white" }),
        React.createElement("path", { d: "M0 12H24H0ZM8.66667 0V24V0Z", fill: "black" }),
        React.createElement("path", { d: "M0 12H24M8.66667 0V24", stroke: "#002F6C", strokeWidth: "4.36364" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_40010504_56381" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
export default FiFlag;
//# sourceMappingURL=fi.js.map